import { apiWrapper } from "@/services/api";

// 取り消しをすると、「予約取消し済み」(ticketing_status:03)になる
export const putTicketingStatus = async (id, method, params) => {
  let requestParams;
  let response;
  // 予約→購入
  if (method === "purchase") {
    requestParams = params;
    // 予約→取り消し
  } else if (method === "cancel") {
    requestParams = {
      ticketing_status: "reservated_canceled",
    };
  }

  try {
    response = await apiWrapper(
      "PUT",
      `/mfitt/sbps/limited_express_tickets/${id}/ticketing_status`,
      requestParams
    );
    console.log("putTicketingStatus response.data :>> ", response.data);
  } catch (err) {
    console.log('ERROR"" putTicketingStatus():', err);
    throw err;
  }
  return response.data;
};
